<!-- 返回顶部的组件 -->
<template>
<div :class="classes" :style="styles" @click="back">
  <slot>
    <div :class="innerClasses">
      <i class="el-icon-arrow-up"></i>
    </div>
  </slot>
</div>
</template>

<style lang="less" scoped>
.back-top {
  z-index: 10;
  position: fixed;
  cursor: pointer;
  display: none;
  &.back-top-show {
    display: block;
  }
  i {
    color: #fff;
    font-size: 24px;
    padding: 8px 12px;
    font-weight: bold;
  }
}

.back-top-inner {
  width: 48px;
  height: 40px;
  background-color: rgba(0, 0, 0, 0.6);
  border-radius: 2px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  transition: all 0.2s ease-in-out;
}
</style>

<script>
import {
  scrollTop
} from '@/libs/utils'
import {
  on,
  off
} from '@/libs/tools'
const prefixCls = 'back-top'

export default {
  props: {
    height: {
      type: Number,
      default: 400
    },
    bottom: {
      type: Number,
      default: 30
    },
    right: {
      type: Number,
      default: 30
    },
    duration: {
      type: Number,
      default: 1000
    },
    container: {
      type: null,
      default: window
    }
  },
  data() {
    return {
      backTop: false
    }
  },
  mounted() {
    on(this.containerEle, 'scroll', this.handleScroll)
    on(this.containerEle, 'resize', this.handleScroll)
  },
  beforeDestroy() {
    off(this.containerEle, 'scroll', this.handleScroll)
    off(this.containerEle, 'resize', this.handleScroll)
  },
  computed: {
    classes() {
      return [
        `${prefixCls}`,
        {
          [`${prefixCls}-show`]: this.backTop
        }
      ]
    },
    styles() {
      return {
        bottom: `${this.bottom}px`,
        right: `${this.right}px`
      }
    },
    innerClasses() {
      return `${prefixCls}-inner`
    },
    containerEle() {
      return this.container === window ? window : document.querySelector(this.container)
    }
  },
  methods: {
    handleScroll() {
      this.backTop = this.containerEle.scrollTop >= this.height
    },
    back() {
      let target = typeof this.container === 'string' ? this.containerEle : (document.documentElement || document.body)
      const sTop = target.scrollTop
      scrollTop(this.containerEle, sTop, 0, this.duration)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/public/back-top.vue